import VueRouter from 'vue-router'
import Vue from 'vue'

import UserRouter from './user'
import UserMobileRouter from './userm'
import VodRouter from './vod'
import VodMobileRouter from './vodm'
import DiskRouter from './disk'
import DiskMobileRouter from './diskm'
import ChatRouter from './chat'
import BookRouter from './book'
import GeoRouter from './geo'
import BlogRouter from './blog'
import AiRouter from './ai'
import MallRouter from './mall'
import ExamRouter from './exam'
import ZhihuRouter from './zhihu'
import BackgroundAccountRouter from './bg_account'
import BackgroundMyRouter from './bg_my'
import BackgroundPostRouter from './bg_post'
import BackgroundSiteRouter from './bg_site'
import BackgroundAdminRouter from './bg_admin'
import BackgroundBackendRouter from './bg_backend'
import BackgroundBlogRouter from './bg_blog'

// 和 VodMobileRouter 冲突
const Index = () => import('views/Index')

// VOD
// ********************************************************************************************************************
const ShortVideo = () => import('views/vod/ShortVideo')
const ShortVideoMobile = () => import('views/vodm/ShortVideoMobile')

// Background
// ********************************************************************************************************************
const Background = () => import('views/bg/Background')
const Dashboard = () => import('views/bg/Dashboard')
const VodAudit = () => import('views/bg/aaa/VideoAudit')
const VodEdit = () => import('views/bg/aaa/VideoEdit')
const PersonalCreate = () => import('views/bg/PersonalCreate')
const PersonalView = () => import('views/bg/PersonalView')
const ResumeCreate = () => import('views/bg/ResumeCreate')
const ResumeView = () => import('views/bg/ResumeView')

// Login
// ********************************************************************************************************************
const Login = () => import('views/Login')
const Register = () => import('views/Register')
const Forgot = () => import('views/Forgot')

// ********************************************************************************************************************
// 使用安装路由插件
Vue.use(VueRouter)
export const constantRoutes = [
  UserRouter,
  UserMobileRouter,
  VodRouter,
  VodMobileRouter,
  DiskMobileRouter,
  ChatRouter,
  BookRouter,
  GeoRouter,
  BlogRouter,
  MallRouter,
  ExamRouter,
  AiRouter,
  ZhihuRouter,
  /* {
    path: '/',
    name: 'Index',
    component: Index,
    meta: { needAuth: false }
  },*/
  {
    path: '/vod_audit/:id',
    name: 'VodAudit',
    component: VodAudit,
    meta: { needAuth: true }
  },
  {
    path: '/vod_edit/:id',
    name: 'VodEdit',
    component: VodEdit,
    meta: { needAuth: true }
  },
  {
    path: '/short',
    name: 'ShortVideoIndex',
    component: ShortVideoMobile,
    meta: { needAuth: false }
  },
  {
    path: '/vod/short',
    name: 'ShortVideo',
    component: ShortVideo,
    meta: { needAuth: false }
  },
  {
    path: '/personal_create',
    name: 'PersonalCreate',
    component: PersonalCreate,
    meta: { needAuth: false }
  },
  {
    path: '/personal_view',
    name: 'PersonalView',
    component: PersonalView,
    meta: { needAuth: false }
  },
  {
    path: '/personal_resume_create',
    name: 'ResumeCreate',
    component: ResumeCreate,
    meta: { needAuth: false }
  },
  {
    path: '/personal_resume',
    name: 'ResumeView',
    component: ResumeView,
    meta: { needAuth: false }
  },
  {
    path: '/bg',
    name: 'BackgroundIndex',
    component: Background,
    meta: { needAuth: true, roles: ['tnb_admin', 'tnb_user', 'tnb_disk'] },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
        meta: { needAuth: true, roles: ['tnb_admin', 'tnb_user', 'tnb_disk'] }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { needAuth: false }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { needAuth: false }
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: Forgot,
    meta: { needAuth: false }
  },
  BackgroundAccountRouter,
  BackgroundMyRouter,
  BackgroundPostRouter,
  BackgroundBlogRouter,
  BackgroundAdminRouter,
  BackgroundSiteRouter,
  BackgroundBackendRouter,
  {
    path: '*',
    name: '404',
    component: () => import('@/views/404.vue'),
    meta: { needAuth: false }
  }
]

// 创建路由对象并导出
export default new VueRouter({
  mode: 'history',
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果是通过浏览器后退按钮，则回到之前的滚动位置
      return savedPosition
    } else {
      // 否则每次跳转都滚动到顶部
      return { x: 0, y: 0 }
    }
  }
})
